import { render } from "./RIAssets.vue?vue&type=template&id=58fd574e&scoped=true"
import script from "./RIAssets.vue?vue&type=script&lang=js"
export * from "./RIAssets.vue?vue&type=script&lang=js"

import "./RIAssets.vue?vue&type=style&index=0&id=58fd574e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fd574e"]])

export default __exports__